import React from "react"
import { Button } from "react-bootstrap"

import { isNumber, parseDate, stringifyDate } from "../../../../utils"
import { Required } from "../../../../widgets/utils"
import { ChangeMessage } from "./CreateRunEventLabelModal"

const registration = {
  // TODO - Consider translations
  range_adj_label: "Adjust selected range",
  min_label: "Min",
  max_label: "Max",
  missing_end_ts_msg: (timeExtractor) =>
    `Official ending time is missing. This is max ${
      timeExtractor.name === "Day" ? "day" : "timestamp"
    } for the run.`,
}

export default function UpdateSelectionRange({
  selection = {},
  updateSelection,
  timeExtractor = {},
  run = {},
  isSelecting = false,
  setIsSelecting,
  isEditing = false,
  defaultDetails = {},
}) {
  return (
    <div className={"row"} style={{ marginBottom: "15px" }}>
      <div className={"col-4"}>
        <label>{registration.range_adj_label}:</label>
        <br />
        <Button
          variant={"outline-primary"}
          className={isSelecting ? "btn-selected" : ""}
          onClick={(e) => {
            e.preventDefault()
            setIsSelecting(!isSelecting)
          }}
        >
          <span className={"fa fa-crosshairs"} />
        </Button>
      </div>
      <div className={"col-4"}>
        <label>{`${registration.min_label} [${timeExtractor.name}]:`}</label>
        <ChangeMessage
          isDate={timeExtractor.name !== "Day"}
          isEditing={isEditing}
          current={selection?.min}
          original={defaultDetails?.["min"]}
          label={"value"}
        />
        <div>
          <input
            type={timeExtractor.name === "Day" ? "number" : "datetime-local"}
            style={{ width: "95%" }}
            step={timeExtractor.name !== "Day" ? null : 0.1}
            value={timeExtractor.name === "Day" ? selection.min : stringifyDate(selection.min)}
            onChange={(e) => {
              let val = e.target.value
              if (timeExtractor.name === "Day") {
                if (val < 0) val = 0
                updateSelection({
                  ...selection,
                  min: isNumber(val) ? parseFloat(val) : val,
                })
              } else {
                if (val) {
                  updateSelection({ ...selection, min: parseDate(val) })
                }
              }
            }}
          />
          &nbsp;
          <Required />
        </div>
      </div>
      <div className={"col-4"}>
        <label>{`${registration.max_label} [${timeExtractor.name}]:`}</label>
        <ChangeMessage
          isDate={timeExtractor.name !== "Day"}
          isEditing={isEditing}
          current={selection?.max}
          original={defaultDetails?.["max"]}
          label={"value"}
        />
        <div>
          <input
            type={timeExtractor.name === "Day" ? "number" : "datetime-local"}
            style={{ width: "95%" }}
            step={timeExtractor.name !== "Day" ? null : 0.1}
            value={timeExtractor.name === "Day" ? selection.max : stringifyDate(selection.max)}
            onChange={(e) => {
              let val = e.target.value
              const { placeholder_end_date, ...flagDetails } = selection
              if (timeExtractor.name === "Day") {
                if (val < 0) val = 0
                if (val > run.observation_max_day) val = run.observation_max_day
                updateSelection({ ...flagDetails, max: isNumber(val) ? parseFloat(val) : val })
              } else {
                if (val) {
                  if (val > run.observation_max) val = run.observation_max
                  updateSelection({ ...flagDetails, max: parseDate(val) })
                }
              }
            }}
          />
          &nbsp;
          <Required />
        </div>
        {selection?.placeholder_end_date && (
          <div className={"error-message"}>{registration.missing_end_ts_msg(timeExtractor)}</div>
        )}
      </div>
    </div>
  )
}
